var MToken = require('./component/mToken/MToken')
var Router = require('./lib/routerjs');
var kotemplates = require('./template/kotemplates')
var common = require('./utiles/common')
var routerUtils = require('./utiles/routerUtils')
var Cookies = require("js-cookie")

module.exports = {
    reloadPage: function (html) {
        kotemplates.registerCommons();
        $("body").html("<div id='main'>" + html + "</div>")
        ko.applyBindings({}, $("#main").get(0));
    },
    clear: function () {
        common.clear();
    },
    clearAll: function () {
        this.clear();
        $("body").removeData("user");
    },
    /**
     *  IE 6 不支持query, 不支持params
     *  参数只能自己想办法解析
     */
    initialRoutes: function () {
        var $this = this;
        var router = new Router();
        router.addRoute('#/users/:username', function (req, next) {
            $this.clear();
            var username = req.params.username;
        }).addRoute('#/ssoLogin', function (req, next) {
            $this.clear();
            kotemplates.registerSSOLogin();
            $this.reloadPage(require("./component/sso/ssoLoginIndex.html"));
        }).addRoute("#/sso", function (req, next) {
            sessionStorage.setItem("searchUrl",window.location.href.split("?")[1]);
            if (req.query && req.query.entitlementId) {
                sessionStorage.setItem("entitlementId",req.query.entitlementId);
            }else{
                sessionStorage.removeItem("entitlementId");
            }
            if (req.query && req.query.callBack) {
                sessionStorage.setItem("callBack",req.query.callBack);
            }else{
                sessionStorage.removeItem("callBack");
            }
            if (req.query && req.query.authId) {
                sessionStorage.setItem("authId",req.query.authId);
            }else{
                sessionStorage.removeItem("authId");
            }
            $this.clear();
            kotemplates.registerSSO();
            $this.reloadPage(require("./component/sso/ssoIndex.html"));
        }).addRoute('#/', function (req, next) {
            $this.clearAll();
            // routerUtils.ccbLogin(router);
            setTimeout(function () {
                common.fetch("/auth/isLogin", {
                    success: function (data) {
                        // 初始化Profile
                        if(data.data){
                            common.redirectTo("/#/ssoLogin?service=na3j8azrv30vamqac8yg");
                        }else{
                            common.redirectTo("/#/login" + location.search);
                        }
                    }
                });
            }, 300)
        }).addRoute('#/logout', function (req, next) {
            kotemplates.registerLogout();
            $this.reloadPage(require("./component/logout/logoutIndex.html"));
        }).addRoute('#/prevent', function (req, next) {
            kotemplates.registerPrevent();
            $this.reloadPage(require("./component/prevent/preventIndex.html"));
        }).addRoute('#/reg', function (req, next) {
            kotemplates.registerReg();
            $this.reloadPage(require("./component/reg/regIndex.html"));
        }).addRoute('#/login', function (req, next) {
            console.log(req.query)
            setTimeout(function () {
                common.fetch("/auth/isLogin", {
                    success: function (data) {
                        // 初始化Profile
                        if(data.data){
                            common.redirectTo("/#/appList");
                        }
                    }
                });
            }, 300)
            if(window.location.href.split("?")[1]){
                var searchs = common.urlSearch(window.location.href);
                if(searchs.service){delete searchs.service};
                if(searchs.callBack){delete searchs.callBack};
                var searchUrl = common.objToSearchUrl(searchs);
                sessionStorage.setItem("searchUrl",searchUrl);
            }
            if (req.query && req.query.state) {
                sessionStorage.setItem("state",req.query.state);
            }
            if (req.query && req.query.service) {
                sessionStorage.setItem("service",req.query.service);
            }
            if (req.query && req.query.callBack) {
                sessionStorage.setItem("callBack",req.query.callBack);
            }
            $this.clear();
            kotemplates.registerLogin();
            $this.reloadPage(require("./component/login/loginIndex.html"));
        }).addRoute('#/wechat-bind', function (req, next) {
            $this.clear();
            kotemplates.registerWechatBind();
            $this.reloadPage(require("./component/login/wechatBind/WechatBindIndex.html"))
        }).addRoute('#/resetPassword', function (req, next) {
            $this.clear();
            if (req.query && req.query.badPassword) {
                $('body').data('badPassword', {
                    token: req.query.token,
                });
            }
            if (req.query && req.query.type) {
                $('body').data('type', {
                    type: req.query.type,
                });
            }
            kotemplates.registerRestPassword();
            $this.reloadPage(require("./component/resetPassword/resetPasswordIndex.html"))
        }).addRoute('#/updatePassword', function (req, next) {
            $this.clear();
            kotemplates.registerRestPassword();
            $this.reloadPage(require("./component/resetPassword/updatePassword.html"))
        }).addRoute('#/setPhone', function (req, next) {
            $this.clear();
            kotemplates.registerRestPassword();
            $this.reloadPage(require("./component/resetPassword/setPhone.html"))
        }).addRoute('#/mailRest', function (req, next) {
            $this.clear();
            $this.reloadPage(require("./component/resetPassword/mailRest.html"))
        }).addRoute('#/appList', function (req, next) {
            $this.clear();
            kotemplates.registerAppList();
            $this.reloadPage(require("./component/appList/appListIndex.html"))
        }).addRoute('#/shopList', function (req, next) {
            $this.clear();
            kotemplates.registerShopList();
            $this.reloadPage(require("./component/shopList/shopListIndex.html"))
        }).addRoute('#/track', function (req, next) {
            $this.clear();
            kotemplates.registerTrack();
            $this.reloadPage(require("./component/track/trackIndex.html"))
        }).addRoute('#/userInfo', function (req, next) {
            $this.clear();
            kotemplates.registerUserInfo();
            $this.reloadPage(require("./component/userInfo/userInfoIndex.html"))
        }).addRoute('#/appConfig/:id', function (req, next) {
            $this.clear();
            kotemplates.registerAuthList();
            $this.reloadPage(require("./component/appConfig/appConfigIndex.html"))
        }).addRoute("#/idShield", function (req, next) {
            $this.clear();
            kotemplates.registerIdShield();
            $this.reloadPage(require("./component/idShield/idShield.html"))
        }).addRoute("#/manageAuth/:accountName/:appCode/:appId", function (req, next) {
            $this.clear();
            kotemplates.registerManageAuth();
            $this.reloadPage(require("./component/appConfig/template/manageAuthIndex.html"))
        }).addRoute("#/editAttr/:id/:appId", function (req, next) {
            $this.clear();
            kotemplates.registerEditAttr();
            $this.reloadPage(require("./component/appConfig/template/editAttrIndex.html"))
        }).addRoute("#/recordIndex/:id/:appId/:name", function (req, next) {
            $this.clear();
            kotemplates.registerRecord();
            $this.reloadPage(require("./component/appConfig/template/recordIndex.html"))
        }).addRoute("#/workflow/:type", function (req, next) {
            $this.clear();
            kotemplates.registerWorkHeader();
            kotemplates.registerWorkflow();
            $this.reloadPage(require("./component/workflow/workflowIndex.html"))
        }).addRoute("#/accountApply", function (req, next) {
            $this.clear();
            kotemplates.registerWorkHeader();
            kotemplates.registerAccountApply();
            $this.reloadPage(require("./component/workflow/accountApplyIndex.html"))
        }).addRoute("#/application/:id/:label", function (req, next) {
            $this.clear();
            kotemplates.registerWorkHeader();
            kotemplates.registerWorkflow();
            $this.reloadPage(require("./component/workflow/applicationIndex.html"))
        }).addRoute("#/notice", function (req, next) {
            $this.clear();
            kotemplates.registerNotice();
            $this.reloadPage(require("./component/systemNotice/noticeIndex.html"))
        }).addRoute("#/appSort", function (req, next) {
            $this.clear();
            kotemplates.registerAppListSort();
            $this.reloadPage(require("./component/appSort/appSortIndex.html"))
        }).addRoute("#/entitlement", function (req, next) {
            $this.clear();
            kotemplates.registerEntitlement();
            $this.reloadPage(require("./component/entitlement/EntitlementIndex.html"))
        }).addRoute("#/appManager", function (req, next) {
            $this.clear();
            kotemplates.registerManagerDetail();
            $this.reloadPage(require("./component/appManager/appManagerIndex.html"))
        }).addRoute("#/userTask", function (req, next) {
            $this.clear();
            kotemplates.registerUserTask();
            $this.reloadPage(require("./component/userTask/userTaskIndex.html"))
        }).addRoute("#/appError", function (req, next) {
            $this.clear();
            $this.reloadPage(require("./component/appError.html"))
        }).errors(404, function(err,href){
            common.errorAlert("很抱歉，您要访问的页面不存在！");
        }).run(location.hash);
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/routes.js
// module id = 24
// module chunks = 0